import { createSelector } from "@ngrx/store";
import { IAppState } from "../state/app.state";
import { ISearchState } from "../state/search.state";


const selectSearchState = (state: IAppState) => state.searchState;

export const selectSearchCriteria = createSelector(selectSearchState, (state: ISearchState) => state.criteria);
export const selectSearchResults = createSelector(selectSearchState, (state: ISearchState) => state.results);
